import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import LabEnteryTable from "./labEnteryTable"
import "../../Patient/list.scss"

const LabEnteryTableContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
           <LabEnteryTable />
        </>
      </div>
    </div>
  )
}

export default LabEnteryTableContainer